<template>
    <el-drawer :modal="false" 
        title="Fund Details"
        :visible.sync="drawerFundDetails"
        class="drawer-fund-details"
        size="60%"
    >
        <div slot="title">
            <span>Fund Details</span>
            <p class="text-xs text-muted">Ref. No: ICSB_JVF-#003119  |  OR No: IJVF/2023119</p>
        </div>

        
        <b-container>
            <b-row>
                <b-col cols="12" md="6">
                    <b-card no-body>
                        <b-card-header>
                            <b-row align-h="between">
                                <b-col cols="auto">
                                    <h3>JV Fund 1.0-15%</h3>
                                    <p class="text-xs text-muted">Half yearly (24 months)</p>
                                </b-col>
                                <b-col cols="auto">
                                    <b-icon icon="three-dots-vertical" scale="1.5" class="cursor-pointer"></b-icon>
                                </b-col>
                            </b-row>
                        </b-card-header>
                        <div class="p-3">
                            <b-row>
                                <b-col cols="6">
                                <p class="text-xs text-muted">UTD Profit (%)</p> 
                                <p class="font-weight-600 text-success">RM {{ 9600 | moneyFormatter }}</p>
                                </b-col>
                                <b-col cols="6">
                                <p class="text-xs text-muted">Contribution Amount</p> 
                                <p class="font-weight-600">RM {{ 64000 | moneyFormatter }}</p>
                                </b-col>
                                <b-col cols="6">
                                <p class="text-xs text-muted">Start Date</p> 
                                <p class="font-weight-600">27 Jul 2023</p>
                                </b-col>
                                <b-col cols="6">
                                <p class="text-xs text-muted">UTD Interest Released</p> 
                                <p class="font-weight-600">RM {{ 11250 | moneyFormatter }}</p>
                                </b-col>
                                <b-col cols="6">
                                <p class="text-xs text-muted">Mature Date</p> 
                                <p class="font-weight-600">27 Jul 2025</p>
                                </b-col>
                                <b-col cols="6">
                                <p class="text-xs text-muted">Lot per 10K (Profit p.a)</p> 
                                <p class="font-weight-600">6.4 lot (15.0%)</p>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>

                    <b-card no-body class="p-3">
                        <b-row align-h="between">
                            <b-col cols="auto">
                                <p class="text-xs text-muted">Months left until mature date</p> 
                                <p class="font-weight-600 text-danger">4 months</p>
                            </b-col>
                            <b-col cols="auto">
                                <el-button plain type="primary">Renew</el-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>

                <b-col cols="12" md="6">
                    <b-card no-body class="p-3">
                        <h3>Profit Growth</h3>
                        <div id="chart">
                            <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
                        </div>
                    </b-card>
                </b-col>
            </b-row>

            <b-row class="my-3" align-h="between">
                <b-col cols="auto">
                    <h4 class="mb-0">Transaction History</h4>
                </b-col>
                <b-col cols="auto" class="d-flex align-items-center">
                    <el-button type="text">
                        View Fund Statement
                    </el-button>
                    <el-date-picker
                        v-model="date_filter"
                        type="date"
                        placeholder="Pick a day"
                        class="ml-4"
                    ></el-date-picker>
                </b-col>
            </b-row>

            <div class="card-table-simple mb-4">
                <b-table-simple responsive class="mb-0">
                    <b-thead>
                        <b-tr>
                            <b-th>Date</b-th>
                            <b-th>Transaction No.</b-th>
                            <b-th>Amount (RM)</b-th>
                            <b-th>Tenure</b-th>
                            <b-th>Status</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                            <b-tr v-for="(data, index) in tableData" :key="index">
                                <b-td>{{ data.date }}</b-td>
                                <b-td>{{ data.transaction_no }}</b-td>
                                <b-td>{{ data.amount }}</b-td>
                                <b-td>{{ data.tenure }}</b-td>
                                <b-td>{{ data.status }}</b-td>
                                <b-td class="text-primary">
                                    <b-icon icon="three-dots-vertical" scale="1.5" class="cursor-pointer"></b-icon>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                </b-table-simple>
            </div>
        </b-container>
        
    </el-drawer>
</template>
<script>
import { Drawer, Button, DatePicker } from 'element-ui'
import VueApexCharts from 'vue-apexcharts'


export default {
    components: {
        "apexchart": VueApexCharts,
        [Drawer.name]: Drawer,
        [Button.name]: Button,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            drawerFundDetails: false,
            date_filter: '',
            tableData: [
                {
                    date: '27 Jul 2024',
                    transaction_no: '1827 9117 3325',
                    amount: -4800,
                    tenure: '',
                    status: 'Pending Approval'
                }
            ],
            series: [{
                name: 'Completed',
                type: 'area',
                data: [23000, 11000, 22000, 27000, 13000, 22000, 37000, 21000, 44000, 22000, 30000]
            }, {
                name: 'Pending',
                type: 'area',
                data: [44000, 55000, 41000, 67000, 22000, 43000, 21000, 41000, 56000, 27000, 43000]
            }, {
                name: 'Target Sales',
                type: 'area',
                data: [30000, 25000, 36000, 30000, 45000, 35000, 64000, 52000, 59000, 36000, 39000]
            }],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    stacked: false,
                },
                stroke: {
                    width: [0, 2, 5],
                    curve: 'straight'
                },
                fill: {
                    opacity: [0.5, 0.25, 0.1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.5,
                        opacityTo: 0,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: ['01/01/2023', '02/01/2023', '03/01/2023', '04/01/2023', '05/01/2023', '06/01/2023', '07/01/2023',
                '08/01/2023', '09/01/2023', '10/01/2023', '11/01/2023'
                ],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: 'datetime'
                },
                yaxis: {
                    min: 0,
                    labels: {
                        formatter: (value) => { 
                            if (value >= 1000) {
                                return (value / 1000).toFixed(0) + 'k';
                            }
                            return value.toLocaleString(undefined, { minimumFractionDigits: 2 });
                         },
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return 'RM ' + y.toLocaleString(undefined, {minimumFractionDigits: 2});
                        }
                        return y;
                    
                        }
                    }
                }
            },
        }
    },
    methods: {
        viewFundDetails() {
            this.drawerFundDetails = !this.drawerFundDetails;
        }
    }
}
</script>